<template>
  <div class="kurama-select" :tabindex="tabindex" @blur="masOptions = false">
    <div class="selected container-multiple" :class="{ masOptions: masOptions }" @click="seeList()">
        <!-- <input type="checkbox" v-model="inputChek" @click="seleccionarTodos();$emit('KuramaSelectMultiple', options);" @blur="clickOutsideSelect()">  -->
        <vs-checkbox class="check-primary" v-model="inputChek"  @click="seleccionarTodos();$emit('KuramaSelectMultiple', options);" @blur="clickOutsideSelect()"></vs-checkbox>
        <input type="text" @keydown="clickDownUpSelect($event)" v-model.trim="inputBuscar" class="kurama-select-input" :placeholder="placeholder" :disabled="disable">
    </div>
    <div :id="idSelect" class="items-multiple" :class="{ selectHide: !masOptions }" :style="{height: hSelect, maxHeight: mHSelect}" @blur="clickOutsideSelect()">
      <div v-for="(option,i) of buscarInOptions" :key="i" @click="select(option);$emit('KuramaSelectMultiple', seleccionados);">
          <!-- <input :checked="option.check" type="checkbox" v-model="option.check">  -->
          <!-- <vs-checkbox :checked="option.check" type="checkbox" v-model="option.check" class="check-primary"></vs-checkbox> -->
          <!-- {{ option.text }} -->
          <input :checked="option.check" class="kurama-input-checked" type="checkbox" v-model="option.check">  <label for="check1"> {{ option.text }}</label>
      </div>
      <div class="nullOption_multi" v-if="buscarInOptions.length == 0">
        Ninguna coincidencia
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder:{
      type: String,
      default: 'Seleccionar opción'
    },
    disable:{
      type: Boolean,
      default: false
    },
    idSelect:{
      type: String,
      default: 'selectMultiple'
    },
    options: {
      type: [],
      required: true,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      inputBuscar:'',
      inputChek:false,
      seleccionados: [],
      masOptions: false,
      hSelect: '120px',
      mHSelect: 'none',
    };
  },
methods:{
  select:function(item)
  {
    let existe = this.options.filter(x=>  x.id== item.id);
    if  (existe.length > 0)
    {
      this.options.filter(x=>  x.id== item.id)[0].check =!item.check;
    }
    else 
    {
      if (this.options.filter(x=>  x.check == true).length != this.options.length) {
        this.inputChek = false
      }
      else if (this.options.filter(x=>  x.check == false).length != this.options.length) {
        this.inputChek = true
      }
    }
    this.seleccionados = this.options.filter(x=>  x.check == true);

  },
  seleccionarTodos:function()
  {
    if(this.inputBuscar !="") {
        if(this.options.length > 0)
        {
          this.options.filter(x=>  x.text.toLowerCase().includes(this.inputBuscar.toLowerCase())).forEach(x => {
            x.check = !this.inputChek;
          });
        }
    }
    else 
    {
      if(this.options.length > 0)
      {
        this.options.forEach(x => {
          x.check = !this.inputChek;
        });
      }
    }
  },
  clickOutsideSelect: function(){
    setTimeout(() => this.masOptions = false, 300);
  },
  clickDownUpSelect: function(event){
    let listGroup = document.querySelector('#'+this.idSelect+'.items-multiple');
    let containerScroll = document.querySelector('#'+this.idSelect);

     // Obtener todos los elementos
    let items = listGroup.querySelectorAll('div');
     // Saber si alguno está activo
    let actual = Array.from(items).findIndex(item => item.classList.contains('active'));
    // Analizar tecla pulsada
    if(event.keyCode == 13) {
        // Tecla Enter, evitar que se procese el formulario
        event.preventDefault();
        // ¿Hay un elemento activo?
        if(items[actual]) {
            // Hacer clic
            items[actual].click();
        }
    } if(event.keyCode == 38 || event.keyCode == 40) {
        // Flecha arriba (restar) o abajo (sumar)
        if(items[actual]) {
            // Solo si hay un elemento activo, eliminar clase
            items[actual].classList.remove('active');
        }
        // Calcular posición del siguiente
        actual += (event.keyCode == 38) ? -1 : 1;
        // Asegurar que está dentro de los límites
        if(actual < 0) {

            actual = 0;
        } else if(actual >= items.length) {
            actual = items.length - 1;
        }
        // Asignar clase activa
        items[actual].classList.add('active');
        if (event.keyCode == 40) return containerScroll.scrollBy(0, 35);
        if (event.keyCode == 38) return containerScroll.scrollBy(0, -35);
    }
  },
  seeList: function(){
    if(!this.disable){
      this.masOptions = !this.masOptions;
    } else{
      this.masOptions = false;
    }

  }
},
computed:{
        buscarInOptions(){ 
            if (this.inputBuscar !="") {
                return this.options.filter(x=>  x.text.toLowerCase().includes(this.inputBuscar.toLowerCase()));
            }
            return this.options;
        }
    },
    watch:{
      inputBuscar: function(){
        if (this.inputBuscar.length === 0) {
          this.masOptions = true;
          this.hSelect = '120px'
        }else{
          this.hSelect = 'auto'
        }
      },
      inputChek: function(){
        if (!this.inputChek) {
           this.$emit('KuramaSelectMultiple', []);
        }
      }
    },
mounted() {
    //this.$emit("KuramaSelectMultiple", this.seleccionado);
  }
};
</script>